import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { handleShowPassword } from "../../../utils";
import Button from "../../../components/common/Button";
import Form from "../../../components/common/Form";
import Input from "../../../components/common/Input";
import Logo from "../../../components/logo/Logo";
import { OnPasswordReset } from "./queries";
import skillOffer from "../../../svg/skill-offer.svg";
import active_lock from "../../../svg/active-lock.svg";
import active_info from "../../../svg/active-info.svg";
import disable_lock from "../../../svg/disable-lock.svg";
import active_eye from "../../../svg/active-eye.svg";
import disable_eye from "../../../svg/disable-eye.svg";
import "./index.scss";
import LightButton from "../../../components/common/Light_button";
import FormModal from "../../../components/Modal/formModal";
import LeftBase from "../../../components/common/LeftBase";

function ResetPassword() {
    const [passwords, setPasswords] = useState({});
    const [openModal,setOpenModal] =useState(false)
    const [showPassword, setShowPassword] = useState({ newPassword: false, confirmPassword: false });
    const [disabled, setDisabled] = useState(true);
    const [error,setError]=useState({apiError:''})
    const { token } = useParams();

    const navigate = useNavigate()
    const sucessHandler = (resetSucess) => {
        setOpenModal(true)
    };
    const { mutate: resetPassword } = OnPasswordReset(sucessHandler,error,setError);
    const handleSubmit = (e) => {
        e.preventDefault();
        const queryParams = {
            header: { token: token },
            passwords
        }
        resetPassword(queryParams)
    };

    const handleChange = (e) => {
        const { name, value } = e.target
        setPasswords({ ...passwords, [name]: value });
    };

    useEffect(() => {
        if (passwords?.newPassword) {
            setDisabled(passwords?.newPassword !== passwords?.confirmPassword)
        }
    }, [passwords])
    const handleModalSubmit=()=>{
        setOpenModal(false)
        navigate('/')
    }

    return (
        <div className="container-flex reset-page">
            <div className="row h-100">
                <div className="col-lg-4 col-xl-4 d-none d-lg-block left-base position-relative left-base">
                    {/* <img src={skillOffer} alt="skill offer" className="p-3 mt-5 w-90" />
                    <div className="text-start text-white w-90 m-auto py-2 px-3">
                        <p>lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. labore eta.
                        </p>
                    </div> */}
                    <LeftBase showBackto={false}/>
                </div>
                <div className="col-lg-8 col-xl-8 col-md-12 col-sm-12 m-auto">
                    <div className="frame w-75 m-auto">
                        <Logo />
                        <h4 className="mt-40 mb-1">RESET PASSWORD</h4>
                        <p className="sub_title">
                           Almost there. Choose a password that is unique to you.
                        </p>
                        <Form onSubmit={handleSubmit}>
                            <Input
                                name="newPassword"
                                handleChange={handleChange}
                                type={!showPassword?.newPassword ? "password" : "text"}
                                labelClass={passwords?.newPassword ? "" : 'hidden'}
                                preIconClass={passwords?.newPassword ? active_lock : disable_lock}
                                postIconClass={passwords?.newPassword ? active_eye : disable_eye}
                                value={passwords.newPassword}
                                label="New Password"
                                placeholder="New Password"
                                className={
                                    passwords?.newPassword
                                        ? "form-control with_icon active-input"
                                        : "form-control with_icon grey-input"
                                }
                                onIconClick={(e) =>
                                    handleShowPassword(setShowPassword, showPassword, 'newPassword')
                                }
                                labelIcon={active_info}
                                pattern="^(?=(?:.*[a-z]){1,})(?=(?:.*[A-Z]){1,})(?=(?:.*\d){1,})(?=(?:.*[!@#$%^&*-]){1,}).{8,}$"
                                title="Password should be of 8 character with one number, one capital letter and a special character."
                            />
                            <Input
                                name="confirmPassword"
                                handleChange={handleChange}
                                type={!showPassword?.confirmPassword ? "password" : "text"}
                                labelClass={passwords?.confirmPassword ? "" : "hidden"}
                                preIconClass={passwords?.confirmPassword ? active_lock : disable_lock}
                                postIconClass={passwords?.confirmPassword ? active_eye : disable_eye}
                                value={passwords.confirmPassword}
                                label="Re-enter New Password"
                                placeholder="Re-enter New Password"
                                className={
                                    passwords?.confirmPassword
                                        ? "form-control with_icon active-input"
                                        : "form-control with_icon grey-input"
                                }
                                onIconClick={() =>
                                    handleShowPassword(setShowPassword, showPassword, 'confirmPassword')
                                }
                                pattern="^(?=(?:.*[a-z]){1,})(?=(?:.*[A-Z]){1,})(?=(?:.*\d){1,})(?=(?:.*[!@#$%^&*-]){1,}).{8,}$"
                                title="Password should be of 8 character with one number, one capital letter and a special character."
                            />
                            <div className="label-error">{error?.apiError}</div>
                            <div className="mb-4 mt-4">
                                <Link to="/">
                                    <LightButton title="Cancel" />
                                </Link>
                                <Button className={disabled ? "custom_button reset_button disabled" : "custom_button reset_button"} type="submit" title="Submit" disabled={disabled} />
                            </div>
                        </Form>
                    </div>
                </div>
                <FormModal show={openModal} submitButtonTitle='Login' customClass={"verify_update_popup"} onSubmit={handleModalSubmit} modalHeading='Password Updated' handleClose={()=>setOpenModal(false)} informationText={`Your password has been changed successfully`} lowerInformationText="Please login with your new password" ><></></FormModal>
            </div>
        </div>
    );
}
export default ResetPassword;
